// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__ReWC2","title":"AfterBackImages_title__2JknM","images":"AfterBackImages_images__2nJO5"};